import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Sidenav from "../../vendor/libs/sidenav";
import layoutHelpers from "./helpers";
import { Link } from "react-router-dom";

class LayoutSidenav extends Component {
  layoutSidenavClasses() {
    let bg = this.props.sidenavBg;

    if (
      this.props.orientation === "horizontal" &&
      (bg.indexOf(" sidenav-dark") !== -1 ||
        bg.indexOf(" sidenav-light") !== -1)
    ) {
      bg = bg
        .replace(" sidenav-dark", "")
        .replace(" sidenav-light", "")
        .replace("-darker", "")
        .replace("-dark", "");
    }

    return (
      `bg-${bg} ` +
      (this.props.orientation !== "horizontal"
        ? "layout-sidenav"
        : "layout-sidenav-horizontal container-p-x flex-grow-0")
    );
  }

  toggleSidenav(e) {
    e.preventDefault();
    layoutHelpers.toggleCollapsed();
  }

  isMenuActive(url) {
    return this.props.location.pathname.indexOf(url) === 0;
  }

  isMenuOpen(url) {
    return (
      this.props.location.pathname.indexOf(url) === 0 &&
      this.props.orientation !== "horizontal"
    );
  }

  render() {
    return (
      <Sidenav
        orientation={this.props.orientation}
        className={this.layoutSidenavClasses()}
      >
        {this.props.orientation !== "horizontal" && (
          <React.Fragment>
            <div className="app-brand demo">
              <span className="app-brand-logo demo bg-primary">
                <div className="text-white">G</div>
              </span>
              <Link
                to="/"
                className="app-brand-text demo sidenav-text font-weight-normal ml-2"
              >
                Galitra
              </Link>
              <a
                href="#toggle"
                className="layout-sidenav-toggle sidenav-link text-large ml-auto"
                onClick={this.toggleSidenav}
              >
                <i className="ion ion-md-menu align-middle"></i>
              </a>
            </div>
            <Sidenav.Divider className="mt-0" />
          </React.Fragment>
        )}

        {/* Inner */}
        <div
          className={`sidenav-inner ${
            this.props.orientation !== "horizontal" ? "py-1" : ""
          }`}
        >
          <Sidenav.RouterLink to="/" exact={true} icon="ion ion-ios-contact">
            Home
          </Sidenav.RouterLink>
          <Sidenav.Menu
            linkText="Paramétrage"
            icon="ion ion-md-switch"
            open={this.isMenuOpen("/parametrage")}
            active={this.isMenuActive("/parametrage")}
          >
            <Sidenav.Menu
              linkText="Catalogue"
              active={this.isMenuActive("/parametrage/catalogue")}
              open={this.isMenuOpen("/parametrage/catalogue")}
            >
              <Sidenav.RouterLink
                exact={true}
                to="/parametrage/catalogue/article"
              >
                Article
              </Sidenav.RouterLink>
              <Sidenav.RouterLink
                exact={true}
                to="/parametrage/catalogue/famille"
              >
                Famille
              </Sidenav.RouterLink>
              <Sidenav.RouterLink
                exact={true}
                to="/parametrage/catalogue/numerisation"
              >
                Numérisation
              </Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu
              linkText="Stock"
              active={this.isMenuActive("/parametrage/stock")}
              open={this.isMenuOpen("/parametrage/stock")}
            >
              <Sidenav.RouterLink
                exact={true}
                to="/parametrage/stock/reservoir"
              >
                Reservoir
              </Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu
              linkText="CRM"
              active={this.isMenuActive("/parametrage/crm")}
              open={this.isMenuOpen("/parametrage/crm")}
            >
              <Sidenav.RouterLink exact={true} to="/parametrage/crm/client">
                Client
              </Sidenav.RouterLink>
              <Sidenav.RouterLink
                exact={true}
                to="/parametrage/crm/fournisseur"
              >
                Fournisseur
              </Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu
              linkText="Transport"
              active={this.isMenuActive("/parametrage/transport")}
              open={this.isMenuOpen("/parametrage/transport")}
            >
              <Sidenav.RouterLink
                exact={true}
                to="/parametrage/transport/vehicule"
              >
                Véhicule
              </Sidenav.RouterLink>
              <Sidenav.RouterLink
                exact={true}
                to="/parametrage/transport/chauffeur"
              >
                Chauffeur
              </Sidenav.RouterLink>
            </Sidenav.Menu>
          </Sidenav.Menu>

          <Sidenav.Menu
            linkText="Achat"
            icon="ion ion-md-switch"
            open={this.isMenuOpen("/achat")}
            active={this.isMenuActive("/achat")}
          >
            <Sidenav.RouterLink exact={true} to="/achat/commandes">
              Bon de commandes
            </Sidenav.RouterLink>
            <Sidenav.RouterLink exact={true} to="/achat/receptions">
              Bon de réception
            </Sidenav.RouterLink>
            <Sidenav.RouterLink exact={true} to="/achat/factures">
              Facture
            </Sidenav.RouterLink>
            <Sidenav.RouterLink exact={true} to="/achat/avoirs">
              Facture avoir
            </Sidenav.RouterLink>
            <Sidenav.RouterLink exact={true} to="/">
              Tableau de bord
            </Sidenav.RouterLink>
          </Sidenav.Menu>

          <Sidenav.Menu
            linkText="Vente"
            icon="ion ion-md-switch"
            open={this.isMenuOpen("/vente")}
            active={this.isMenuActive("/vente")}
          >
            <Sidenav.RouterLink exact={true} to="/vente/devis">
              Devis
            </Sidenav.RouterLink>
            <Sidenav.RouterLink exact={true} to="/vente/bgs">
              Bon Gaz
            </Sidenav.RouterLink>
            <Sidenav.RouterLink exact={true} to="/vente/bls">
              Bon de livraison
            </Sidenav.RouterLink>
            <Sidenav.RouterLink exact={true} to="/">
              Tableau de bord
            </Sidenav.RouterLink>
          </Sidenav.Menu>

          <Sidenav.Menu
            linkText="Gestion des prix"
            icon="ion ion-md-switch"
            open={this.isMenuOpen("/prix")}
            active={this.isMenuActive("/prix")}
          >
            <Sidenav.RouterLink exact={true} to="/prix/divers">
              Divers articles
            </Sidenav.RouterLink>
          </Sidenav.Menu>
          {/* <Sidenav.RouterLink
            to="/Achats"
            exact={true}
            icon="ion ion-ios-contact"
          >
            Demandes d'achats
          </Sidenav.RouterLink> */}

          {/* <Sidenav.RouterLink
            to="/Receptions"
            exact={true}
            icon="ion ion-ios-contact"
          >
            Réception
          </Sidenav.RouterLink> */}
          {/* <Sidenav.RouterLink
            to="/Facturation"
            exact={true}
            icon="ion ion-ios-contact"
          >
            Facturation
          </Sidenav.RouterLink> */}
          {/* <Sidenav.RouterLink
            to="/FactureAvoir"
            exact={true}
            icon="ion ion-ios-contact"
          >
            Facture Avoir
          </Sidenav.RouterLink> */}
          {/* <Sidenav.RouterLink
            to="/accountSettings"
            exact={true}
            icon="ion ion-md-desktop"
          >
            Account Settings
          </Sidenav.RouterLink> */}
          {/* <Sidenav.RouterLink
            to="/users"
            exact={true}
            icon="ion ion-md-desktop"
          >
            Users
          </Sidenav.RouterLink> */}
          {/* <Sidenav.RouterLink to="/user" exact={true} icon="ion ion-md-desktop">
            User View
          </Sidenav.RouterLink> */}
          {/* <Sidenav.RouterLink
            to="/user_edit"
            exact={true}
            icon="ion ion-md-desktop"
          >
            Edit User
          </Sidenav.RouterLink> */}
          {/* <Sidenav.RouterLink
            to="/login"
            exact={true}
            icon="ion ion-md-desktop"
          >
            Login
          </Sidenav.RouterLink> */}
          {/* <Sidenav.RouterLink
            to="/register"
            exact={true}
            icon="ion ion-md-desktop"
          >
            Register
          </Sidenav.RouterLink> */}
          {/* <Sidenav.RouterLink
            to="/lockscreen"
            exact={true}
            icon="ion ion-md-desktop"
          >
            Lock Screen
          </Sidenav.RouterLink> */}
        </div>
      </Sidenav>
    );
  }
}

LayoutSidenav.propTypes = {
  orientation: PropTypes.oneOf(["vertical", "horizontal"])
};

LayoutSidenav.defaultProps = {
  orientation: "vertical"
};

export default connect((store) => ({
  sidenavBg: store.theme.sidenavBg
}))(LayoutSidenav);
